import React, { useEffect, useState } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import { CDBTable, CDBTableHeader, CDBSpinner, CDBTableBody } from "cdbreact";
import {
  listAllUsers,
  detachUser,
  employeesComissionsEnabled,
} from "../../../services/UserService";
import EditarUsuarioModal from "./EditarUsuarioModal";
import AdicionarUsuarioModal from "./AdicionarUsuarioModal";
import { toast } from "react-toastify";
import { HistoricoServicosUsuario } from "./HistoricoServicosUsuario";
import RelatorioComissoesModal from "./RelatorioComissoesModal";

export const Funcionarios = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [employee, setEmployee] = useState();
  const [comissionEnabled, setComissionEnabled] = useState(false);
  const [relatorioComissionOpen, setRelatorioComissionOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    handleSidebarToggle();
    listUsers();
  }, []);

  function listUsers(delay) {
    setIsLoading(true);
    employeesComissionsEnabled().then((response) => {
      setComissionEnabled(response);
    });
    listAllUsers(delay)
      .then((response) => {
        setUsers(response);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        console.error("[listUsers] error: ", e);
      });
  }

  function removeUser(userId) {
    const execute = window.confirm(
      "Você tem certeza que de seja excluir este usuário?"
    );

    if (execute) {
      detachUser(userId)
        .then((response) => {
          toast.success(response);
          listUsers(false);
        })
        .catch((e) => {
          console.error("[removeUser] error: ", e);
        });
    }
  }

  function disableRemoveButton(userId) {
    const disable = localStorage.getItem("userId") == userId;
    return disable;
  }

  function handleSidebarToggle() {
    const isMobile = window.innerWidth <= 720;
    if (isMobile) {
      setToggled(true);
    }
  }

  function handleHistoryClick(employee) {
    setEmployee(employee);
    setOpenHistory(true);
  }

  return (
    <div className="d-flex">
      <div>
        <Sidebar toggled={toggled} />
      </div>
      <div className="main-content-wrapper">
        <Navbar toggled={toggled} setToggled={setToggled} />
        <div style={{ height: "100%" }}>
          <div
            style={{
              padding: "20px 5%",
            }}
          >
            <div>
              <div className="mt-3 w-100">
                <div className="d-flex justify-content-between align-items-center mb-0">
                  <h3 className="fw-bold text-dark">Funcionários</h3>
                  <AdicionarUsuarioModal listUsers={listUsers} />
                </div>

                <div className="d-flex mt-3 mb-3">
                  {comissionEnabled && (
                    <div className="d-flex mb-3">
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none text-muted p-0 d-flex align-items-center small fw-medium"
                        onClick={() => setRelatorioComissionOpen(!relatorioComissionOpen)}
                      >
                        <i className="fa fa-file me-2 text-primary"></i>
                        Relatório de comissões
                      </button>

                      {relatorioComissionOpen && (
                        <RelatorioComissoesModal
                          setRelatorioComissionOpen={setRelatorioComissionOpen}
                        />
                      )}
                    </div>
                  )}

                  {openHistory && (
                    <HistoricoServicosUsuario
                      employee={employee}
                      openHistory={openHistory}
                      setOpenHistory={setOpenHistory}
                    />
                  )}
                </div>

                {isLoading ? (
                  <div className="d-flex justify-content-center p-3">
                    <CDBSpinner dark />
                  </div>
                ) : (
                  <CDBTable className="alcon-table" responsiveSm borderless>
                    <thead>
                      <tr>
                        <th>Funcionário</th>
                        <th>E-mail</th>
                        <th>Função / Cargo</th>
                        {comissionEnabled && <th className="text-center">Comissão</th>}
                        <th className="text-end px-4">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users && users.map((user) => (
                        <tr key={user.id}>
                          {/* Nome com destaque */}
                          <td className="fw-bold text-dark">
                            <div className="d-flex align-items-center">
                              <div className="bg-primary-subtle text-primary rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: '32px', height: '32px', fontSize: '0.8rem' }}>
                                {user.name.charAt(0).toUpperCase()}
                              </div>
                              {user.name}
                            </div>
                          </td>

                          {/* E-mail mais discreto */}
                          <td className="text-muted small">{user.email}</td>

                          {/* Funções como Badges */}
                          <td>
                            {user.roles.map((role, index) => (
                              <span key={index} className="badge bg-light text-primary border me-1 fw-medium" style={{ fontSize: '0.7rem' }}>
                                {role.value}
                              </span>
                            ))}
                          </td>

                          {/* Comissão com destaque numérico */}
                          {comissionEnabled && (
                            <td className="text-center">
                              <span className="fw-bold text-success">
                                {user.comission}<small>%</small>
                              </span>
                            </td>
                          )}

                          {/* Ações usando seu novo .btn-3-dots */}
                          <td className="text-end px-3">
                            <div className="dropdown">
                              <button
                                className="btn btn-link btn-3-dots text-muted shadow-none p-0"
                                type="button"
                                data-bs-toggle="dropdown"
                                data-bs-display="static"
                              >
                                <i className="fas fa-ellipsis-v"></i>
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3">
                                <li>
                                  <EditarUsuarioModal
                                    user={user}
                                    listUsers={listUsers}
                                  />
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                  <button
                                    onClick={() => handleHistoryClick(user)}
                                    className="dropdown-item py-2 d-flex align-items-center"
                                  >
                                    Histórico de Produção
                                  </button>
                                </li>

                                {!disableRemoveButton(user.id) && (
                                  <>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                      <button
                                        onClick={() => removeUser(user.id)}
                                        className="dropdown-item py-2 d-flex align-items-center text-danger"
                                      >
                                        Remover Acesso
                                      </button>
                                    </li>
                                  </>
                                )}
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </CDBTable>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Funcionarios;
